import { useDispatch, useSelector } from "react-redux";
import { 
  fetchCustomerListByEmail 
} from "../../store/actions/customerListActions";

import {
  selectCustomerList,
  selectCustomerListLoading,
  selectCustomerListError,
} from "../../store/reducers/customerListSlice";

export const useCustomerList = () => {
  const dispatch = useDispatch();

  const customerList = useSelector(selectCustomerList);
  const loading = useSelector(selectCustomerListLoading);
  const error = useSelector(selectCustomerListError);

  const fetchCustomerList = async (email) => {
    return await dispatch(fetchCustomerListByEmail(email));
  };

  return {
    fetchCustomerList,
    customerList,
    loading,
    error,
  };
};
